module.exports = __webpack_public_path__ + "static/mission-6-active.171b3279.png";